import { lazy, Suspense, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
// components
import InvoiceDetail from "../views/admin/InvoiceDetail";
import Invoices from "../views/admin/Invoices";

import { Layout, ConfigProvider, theme } from "antd";
import {
  UnorderedListOutlined,
  CalculatorOutlined,
  DashboardOutlined,
  WalletOutlined,
  FileAddOutlined,
  OrderedListOutlined,
  TeamOutlined,
  ShoppingOutlined,
  ContainerOutlined,
  FileSearchOutlined,
} from "@ant-design/icons";
import AppHeader from "../widgets/header";
import AppSidebar from "../widgets/sideBar";
import Loader from "../components/Loader/Loader";

const Summary = lazy(() => import("../views/admin/Summary"));
const SummaryDetailPage = lazy(() =>
  import("../views/admin/Summary/DetailPage")
);
const CreateInvoice = lazy(() => import("../views/admin/CreateInvoice"));
const CreateEstimate = lazy(() => import("../views/admin/createEstimate"));
const InvoiceLists = lazy(() => import("../views/admin/InvoiceLists"));
const InvoiceListsItemDetails = lazy(() =>
  import("../views/admin/InvoiceLists/pages/Invoice-Lists-Item-Details")
);

const EstimateLists = lazy(() => import("../views/admin/EstimateLists"));
const Reports = lazy(() => import("../views/admin/Reports"));
const Imprest = lazy(() => import("../views/admin/Imprest"));
const ImprestDetail = lazy(() => import("../views/admin/ImprestDetail"));
const GeneratePo = lazy(() => import("../views/admin/GeneratePo"));
const PoList = lazy(() => import("../views/admin/PoList"));

// - - - - - N E W - - - - -

const { Content } = Layout;

export default function Admin() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const [selectedKeys, setSelectedKeys] = useState(
    location.pathname.replace(`/admin`, "")
  );

  const menuItems = [
    {
      key: "/summary",
      icon: <DashboardOutlined />,
      label: "Summary",
      path: "/summary",
    },
    {
      key: "/reports",
      icon: <FileSearchOutlined />,
      label: "Reports",
      path: "/reports",
    },
    {
      key: "/imprest",
      icon: <WalletOutlined />,
      label: "Imprest",
      path: "/imprest",
    },
    {
      key: "/create-invoice",
      icon: <FileAddOutlined />,
      label: "Create Invoice",
      path: "/create-invoice",
    },
    {
      key: "/invoice-list",
      icon: <OrderedListOutlined />,
      label: "Invoice Lists",
      path: "/invoice-list",
    },
    {
      key: "/invoices",
      icon: <TeamOutlined />,
      label: "Vendor Invoices",
      path: "/invoices",
    },
    {
      key: "/generate-po",
      icon: <ShoppingOutlined />,
      label: "Generate PO",
      path: "/generate-po",
    },
    {
      key: "/po-list",
      icon: <ContainerOutlined />,
      label: "PO Listing",
      path: "/po-list",
    },
    {
      key: "/create-estimate",
      icon: <CalculatorOutlined />,
      label: "Create Estimate",
      path: "/create-estimate",
    },
    {
      key: "/estimate-list",
      icon: <UnorderedListOutlined />,
      label: "Estimate Lists",
      path: "/estimate-list",
    },
  ];

  return (
    <>
      {/* N E W */}
      <Suspense fallback={<Loader />}>
        <ConfigProvider
          theme={{
            algorithm: theme.defaultAlgorithm,
            token: {
              colorPrimary: "#0471a3",
              colorBgContainer: "rgba(255, 255, 255, 0.9)",
              borderRadius: 12,
            },
            components: {
              Layout: {
                siderBg: "rgba(255, 255, 255, 0.95)",
                headerBg: "rgba(255, 255, 255, 0.9)",
              },
              Menu: {
                itemBg: "transparent",
                itemSelectedBg: "#0471a3",
                itemSelectedColor: "#ffffff",
                itemHoverBg: "rgba(97, 146, 105, 0.1)",
                itemHoverColor: "#0471a3",
                groupTitleColor: "#8c8c8c",
                groupTitleFontSize: "12px",
              },
            },
          }}
        >
          <Layout style={{ minHeight: "100vh" }}>
            <AppSidebar
              collapsed={collapsed}
              menuItems={menuItems}
              role={"admin"}
              selectedKeys={selectedKeys}
              setCollapsed={setCollapsed}
              setSelectedKeys={setSelectedKeys}
            />
            <Layout style={{ marginLeft: collapsed ? 80 : 280 }}>
              {/* <Layout> */}
              {/* - - - - - H E A D E R - - - - - */}
              <AppHeader collapsed={collapsed} setCollapsed={setCollapsed} />
              {/* - - - C O N T E N T - - - - - */}
              <Content
                style={{
                  margin: collapsed ? "16px" : "32px",
                  background:
                    "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                  minHeight: "calc(100vh - 144px)",
                  borderRadius: "24px",
                  position: "relative",
                  overflow: "hidden",
                  transition: "all 0.3s ease",
                }}
              >
                {/* Background decoration */}
                <div
                  style={{
                    position: "absolute",
                    top: "-50%",
                    right: "-20%",
                    width: "600px",
                    height: "600px",
                    background:
                      "radial-gradient(circle, rgba(4, 113, 163, 0.03) 0%, transparent 70%)",
                    borderRadius: "50%",
                    zIndex: 0,
                  }}
                />

                <div
                  style={{ position: "relative", zIndex: 1, padding: "40px" }}
                >
                  <Routes>
                    <Route path="" element={<Navigate to="/admin/summary" />} />
                    <Route path="summary" element={<Summary />} />
                    <Route
                      path="summary/summary_detail/:cardType"
                      element={<SummaryDetailPage />}
                    />
                    <Route path="reports" element={<Reports />} />
                    <Route path="imprest" element={<Imprest />} />
                    <Route path="imprest-detail" element={<ImprestDetail />} />
                    <Route path="create-invoice" element={<CreateInvoice />} />
                    <Route
                      path="create-estimate"
                      element={<CreateEstimate />}
                    />
                    <Route path="invoice-list" element={<InvoiceLists />} />
                    <Route
                      path="invoice-list-detail"
                      element={<InvoiceListsItemDetails />}
                    />

                    <Route path="estimate-list" element={<EstimateLists />} />
                    <Route
                      path="invoice-detail/:order_id"
                      element={<InvoiceDetail />}
                    />
                    <Route path="invoices" element={<Invoices />} />
                    <Route path="generate-po" element={<GeneratePo />} />
                    <Route path="po-list" element={<PoList />} />
                  </Routes>
                </div>
              </Content>
              {/* - - - F O O T E R - - - - - */}
              {/* <AppFooter /> */}
            </Layout>
          </Layout>
        </ConfigProvider>
      </Suspense>
    </>
  );
}
